// extracted by mini-css-extract-plugin
export default {"title":"K3-z","warning":"L3-z","sizeOptionsLegendText":"M3-z"};